"use strict";
/**
 * 资讯数据
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelfSelectStockNews = exports.getNewsByColumn = exports.getLastNews = void 0;
var web_1 = __importDefault(require("../../config/web"));
/**
 * 获取最新资讯 废弃
 * @param count 条数
 * @returns
 */
// export async function getLastNewsOld(count = 20): Promise<Array<{
//   Art_Title: string,
//   Art_Code: string,
//   Art_Url: string,
//   Art_UniqueUrl: string,
//   Art_Showtime: string
// }>> {
//   try {
//     let data = await $.ajax({
//       url: `${config.getUrl('zixun_api')}api/CmsNews?count=20&cb=?`,
//       type: 'GET',
//       dataType: 'jsonp',
//       data: {
//         count
//       }
//     })
//     if (data?.Result instanceof Array) {
//       return data.Result
//     }
//   } catch (error) {
//     console.error(error)
//   }
//   return []
// }
/**
 * 获取最新资讯
 * @param count 条数
 * @returns
 */
function getLastNews(count) {
    if (count === void 0) { count = 20; }
    return __awaiter(this, void 0, void 0, function () {
        var data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, $.ajax({
                            url: "".concat(web_1.default.getUrl('zixun_api_new'), "comm/web/getWebRollNews"),
                            type: 'GET',
                            dataType: 'json',
                            data: {
                                count: count,
                                client: 'web',
                                biz: 'quote_center_roll',
                                req_trace: (new Date()).getTime().toString()
                            }
                        })];
                case 1:
                    data = _a.sent();
                    if ((data === null || data === void 0 ? void 0 : data.data) instanceof Array) {
                        return [2 /*return*/, data.data.map(function (item) {
                                return {
                                    Art_Title: item.title,
                                    Art_Code: item.code,
                                    Art_Url: item.url,
                                    Art_UniqueUrl: item.url,
                                    Art_Showtime: item.showTime
                                };
                            })];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, []];
            }
        });
    });
}
exports.getLastNews = getLastNews;
/**
 * 按频道获取资讯-老接口-废弃
 * @param columns 频道id
 * @param pagesize 每页数量
 * @param pageindex 第几页
 * @returns
 */
// export async function getNewsByColumnOld(columns: string, pagesize = 5, pageindex = 1): Promise<Array<{
//   Art_Title: string,
//   Art_Code: string,
//   Art_Url: string,
//   Art_UniqueUrl: string,
//   Art_Showtime: string
// }>> {
//   try {
//     let data = await $.ajax({
//       url: `${config.getUrl('zixun_api')}api/CmsNews/QueryCmsNewsByColumn?cb=?`,
//       type: 'GET',
//       dataType: 'jsonp',
//       data: {
//         columns,
//         pagesize,
//         pageindex
//       }
//     })
//     if (data?.Result instanceof Array) {
//       return data.Result
//     }
//   } catch (error) {
//     console.error(error)
//   }
//   return []
// }
/**
 * 按频道获取资讯
 * @param columns 频道id
 * @param pagesize 每页数量
 * @param pageindex 第几页
 * @returns
 */
function getNewsByColumn(column, pagesize, pageindex) {
    var _a;
    if (pagesize === void 0) { pagesize = 5; }
    if (pageindex === void 0) { pageindex = 1; }
    return __awaiter(this, void 0, void 0, function () {
        var data, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, $.ajax({
                            url: "".concat(web_1.default.getUrl('zixun_api_new'), "comm/web/getNewsByColumns"),
                            type: 'GET',
                            dataType: 'json',
                            data: {
                                column: column,
                                page_size: pagesize,
                                page_index: pageindex,
                                order: 2,
                                biz: 'web_col',
                                client: 'web',
                                req_trace: (new Date()).getTime().toString()
                            }
                        })];
                case 1:
                    data = _b.sent();
                    if (((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.list) instanceof Array) {
                        return [2 /*return*/, data.data.list.map(function (item) {
                                return {
                                    Art_Title: item.title,
                                    Art_Code: item.code,
                                    Art_Url: item.url,
                                    Art_UniqueUrl: item.uniqueUrl,
                                    Art_Showtime: item.showTime
                                };
                            })];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _b.sent();
                    console.error(error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, []];
            }
        });
    });
}
exports.getNewsByColumn = getNewsByColumn;
// /**
//  * 个股资讯
//  * @param stockcode 股票代码串 例如 601669,601088
//  * @param count 
//  * @returns 
//  */
// export async function getStocksNews(stockcode: string, count = 6): Promise<Array<{
//   Art_Title: string,
//   Art_Code: string,
//   Art_Url: string,
//   Art_UniqueUrl: string,
//   Art_ShowTime: string,
//   StockNames: string
// }>> {
//   try {
//     let data = await $.ajax({
//       url: `${config.getUrl('zixun_api')}api/StockNews?cb=?`,
//       type: 'GET',
//       dataType: 'jsonp',
//       data: {
//         token: 'B2293E122451E3EA784F069ED7EC95E7',
//         pagesize: count,
//         stocks: stockcode,
//         sourceid: 20
//       }
//     })
//     if (data?.Data instanceof Array) {
//       return data.Data
//     }
//   } catch (error) {
//     console.error(error)
//   }
//   return []
// }
// /**
//  * 个股公告
//  * @param stockcode 股票代码串 例如 601669,601088
//  * @param count 
//  * @returns 
//  */
// export async function getStocksNotice(stockcode: string, count = 6): Promise<Array<{
//   Url: string,
//   NoticeTitle: string,
//   NoticeDate: string,
//   SecurityCode: string,
//   SecurityShortName: string,
// }>> {
//   try {
//     let data = await $.ajax({
//       url: `${config.getUrl('zixun_api')}api/StockNews?cb=?`,
//       type: 'GET',
//       dataType: 'jsonp',
//       data: {
//         token: 'B2293E122451E3EA784F069ED7EC95E7',
//         pagesize: count,
//         stocks: stockcode,
//         sourceid: 10
//       }
//     })
//     if (data?.Data instanceof Array) {
//       return data.Data
//     }
//   } catch (error) {
//     console.error(error)
//   }
//   return []
// }
/**
 * 新版个股资讯cms/公告notice
 * @param stockcode 0.300059,0.300033
 * @param count
 * @returns
 */
function SelfSelectStockNews(stockcode, count, business) {
    var _a, _b;
    if (count === void 0) { count = 6; }
    return __awaiter(this, void 0, void 0, function () {
        var data, error_3;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, $.ajax({
                            url: "".concat(web_1.default.getUrl('new_zixun_api'), "comm/web/SelfSelectStockNews?callback=?"),
                            type: 'GET',
                            dataType: 'jsonp',
                            data: {
                                biz: 'quotecenter',
                                client: 'web',
                                req_trace: 'quotecenter_' + (new Date()).getTime(),
                                em_appid: 511,
                                endTime: '',
                                startPos: 0,
                                size: count,
                                business: business,
                                stocks: stockcode
                            }
                        })
                        // console.log(data[business.toLocaleLowerCase()])
                    ];
                case 1:
                    data = _c.sent();
                    // console.log(data[business.toLocaleLowerCase()])
                    if (((_a = data === null || data === void 0 ? void 0 : data[business.toLocaleLowerCase()]) === null || _a === void 0 ? void 0 : _a.data) instanceof Array) {
                        return [2 /*return*/, (_b = data === null || data === void 0 ? void 0 : data[business.toLocaleLowerCase()]) === null || _b === void 0 ? void 0 : _b.data];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _c.sent();
                    console.error(error_3);
                    return [2 /*return*/, []];
                case 3: return [2 /*return*/, []];
            }
        });
    });
}
exports.SelfSelectStockNews = SelfSelectStockNews;
